import React, { useEffect, useState } from "react";
import Header from "../../layout/Header";
import Leftpanel from "../../layout/Leftpanel";
import { Link, useNavigate } from "react-router-dom";
import { getAllIndustryDetailslist } from "../../../../service/BusinessUnit/BusinessUnitService";
import { getIndustryById } from "../../../../service/Department/DepartmentService";
import { getALLGLlist } from "../../../../service/gl/glService";
import {
  AddAccountingDimensions,
  listAccountingDimensions,
  DeleteAccountingDimensions,
  addEditAccountDimension,
  getAccountDimensionById,
} from "../../../../service/AccountingDimensions/AccountingDimensions";
import { toast } from "react-toastify";

const AccountingDimensionsList = () => {
  const navigate = useNavigate();
  const [accountingDimensions, setAccountingDimensions] = useState([]);
  const [glKey, setGlKey] = useState(null);
  const [totalDimantion, setTotalDimantion] = useState(2);
  const _FETCH_GL_KEY = async () => {
    getALLGLlist()
      .then((res) => {
        setGlKey({
          text: res?.data?.data?.glList[0]?.value,
          key: res?.data?.data?.glList[0]?.key,
          id: res?.data?.data?.glList[0]?.id,
        });
      })
      .catch((err) => {
      //  console.log(err);
      });
  };

  const [businessunit, setBusinessunit] = useState([]);
  const [myAccoutingDimensions, setMyAccoutingDimensions] = useState([]);
  // const [accoutingDimensions,setAccoutingDimensions] = useState([{
  //   text:''
  // }]);
  const [department, setDepartment] = useState([]);
  const [selectedBusinessUnitId, setSelectedBusinessUnitId] = useState(null);
  const [selectedDeptId, setSelectedDeptId] = useState(null);
  const [accoutingDimensions, setAccoutingDimensions] = useState("");
  const _FETCH_BUSINESS_UNIT = async () => {
    await getAllIndustryDetailslist().then((res) => {
      setBusinessunit(res.data.data);
    });
  };
  const _FETCH_DEPARTMENT = async (e) => {
    getIndustryById(e.target.value).then((res) => {
      setDepartment(res?.data?.data?.businessUnit?.Departments);
      setSelectedBusinessUnitId(e.target.value);
      setSelectedDeptId(null);
    });
  };

  const _FETCH_ACCOUNTING_DIMENSION = async () => {
    await listAccountingDimensions().then((res) => {
      setMyAccoutingDimensions(res?.data?.infoList);
      // setBusinessunit(res.data.data);
    });
  };

  // getAccountDimensionById
  const _FETCH_ACCOUTING_DIMENSION_BY_ID = async () => {
    getAccountDimensionById((res) => {
      setAccountingDimensions(res.data.infoList);
      //       setAccountingDimensions({
      //       ...accountingDimensions,
      //       dimension2: res.data.infoList[0].dimension2,
      //       dimension3: res.data.infoList[0].dimension3,
      //       dimension4: res.data.infoList[0].dimension4,
      //       dimension5: res.data.infoList[0].dimension5,
      //       dimension6: res.data.infoList[0].dimension6
      //     }
      // )

      // console.log(res.data.infoList[0], "resData")
    }).catch((err) => {
    //  console.log(err);
    });
  };

  useEffect(() => {
    _FETCH_BUSINESS_UNIT();
    _FETCH_ACCOUNTING_DIMENSION();
    _FETCH_GL_KEY();
    _FETCH_ACCOUTING_DIMENSION_BY_ID();
  }, []);

  const [inputFields, setInputFields] = useState([{ id: 0, value: "" }]);

  // Function to add a new input field
  const addInputField = (e) => {
    e.preventDefault();
    if (!(inputFields.length > 5)) {
      const newInputFields = [...inputFields];
      const id = newInputFields[newInputFields.length - 1].id + 1;
      newInputFields.push({ id, value: "" });
      setInputFields(newInputFields);
    }
  };

  // Function to handle input changes
  const handleInputChange = (e, id, value) => {
    e.preventDefault();
    const newInputFields = inputFields.map((field) =>
      field.id === id ? { ...field, value } : field
    );
    setInputFields(newInputFields);

    // inputFields[id]={id,value};
    // setInputFields(inputFields)
  };
  // console.log(inputFields,"inputFields");

  // Function to remove an input field
  const removeInputField = (id) => {
    if (id === 0) return; // Don't remove the first input field
    const newInputFields = inputFields.filter((field) => field.id !== id);
    setInputFields(newInputFields);
  };

  const _CHANGE_DEPT = (e) => {
    setSelectedDeptId(e.target.value);
  };

  const _ON_SUBMIT = (e) => {
    e.preventDefault();
    const data = {
      businessUnitId: Number(selectedBusinessUnitId),
      departmentId: Number(selectedDeptId),
      accountDimension: accoutingDimensions,
    };
    if (!data?.businessUnitId) {
      toast.error("Please select operator unit");
    } else if (!data?.departmentId) {
      toast.error("Please select department");
    } else if (!data?.accountDimension) {
      toast.error("Please select account dimension");
    } else {
      AddAccountingDimensions(data, (res) => {
        if (res.success === false) {
          toast.error(res.message);
        } else {
          toast.success(res.message);
        }

        _FETCH_ACCOUNTING_DIMENSION();
        setSelectedBusinessUnitId(null);
        setSelectedDeptId(null);
        setAccoutingDimensions("");
      });
    }
  };

  const _DELETE_MY_ACCOUTING_DIMENSION = (e, id) => {
    e.preventDefault();
    DeleteAccountingDimensions(id).then((res) => {
      toast.success(res.message);
      _FETCH_ACCOUNTING_DIMENSION();
    });
  };

  const _UPDATE_DIMANTION = async (data) => {
    setTotalDimantion(data);
  };

  const _ADD_GL_KEY = async (e) => {
    e.preventDefault();
    try {
      const data = {
        GLId: glKey.id,
        dimension2: accountingDimensions?.dimension2,
        dimension3: accountingDimensions?.dimension3,
        dimension4: accountingDimensions?.dimension4,
        dimension5: accountingDimensions?.dimension4,
        dimension6: accountingDimensions?.dimension6,
        // id:1
      };
      addEditAccountDimension(data, (res) => {
        toast.success(res.message);
      });
    } catch (error) {
    //  console.log(error);
    }
  };

  const _SET_ACCOUTING_DIMANTION = async (e, index) => {
    e.preventDefault();
    accountingDimensions[index] = { text: e.target.value };
  };

  const _Navigate_EditPage = (e, id) => {
    e.preventDefault();
    navigate(`/edit-accounting-dimensions?id=${id}`);
  };
  return (
    <div className="container-fluid">
      <div className="dbMain accountDimenbg">
        <Leftpanel breadcm="Other" />
        <div className="dbRight">
          <Header
            link="/dashboard"
            title="Configuration > Others > Accounting Dimensions"
            description=""
          />
          <div className="commonBase mb-4">
            <div className="dbtableTop">
              <div className="dbSearch">
                {/* <input type="search" className='form-control' placeholder='Search' />
                        <i className="fa-solid fa-magnifying-glass"></i> */}
                {/* <h6>103 IES connector.</h6> */}
              </div>
              {accountingDimensions.length <= 0 && (
                <div className="dbtableSrchbg">
                  <button className="commonButton">
                    <Link to="/accounting-dimensions">
                      <i className="fa-solid fa-plus"></i> Add Accounting Dimensions
                    </Link>
                  </button>
                </div>
              )}
            </div>
            <div className="dbMaintable co2Table respTable">
              <table>
                <thead>
                  <tr>
                    {/* <th>GL Key</th> */}
                    <th>
                      {accountingDimensions.length !== 0 &&
                        accountingDimensions[0]?.GLFieldName}
                    </th>
                    <th>
                      {accountingDimensions.length !== 0 &&
                        accountingDimensions[0]?.Dimension2FieldName}
                    </th>
                    <th>
                      {accountingDimensions.length !== 0 &&
                        accountingDimensions[0]?.Dimension3FieldName}
                    </th>
                    <th>
                      {accountingDimensions.length !== 0 &&
                        accountingDimensions[0]?.Dimension4FieldName}
                    </th>
                    <th>
                      {accountingDimensions.length !== 0 &&
                        accountingDimensions[0]?.Dimension5FieldName}
                    </th>
                    <th>
                      {accountingDimensions.length !== 0 &&
                        accountingDimensions[0]?.Dimension6FieldName}
                    </th>
                    <th>{accountingDimensions.length !== 0 && "Action"}</th>
                    {/* <th>Dimension 2</th>
                                        <th>Dimension 3</th>
                                        <th>Dimension 4</th>
                                        <th>Dimension 5</th>
                                        <th>Dimension 6</th> */}
                    {/* <th>Action</th> */}
                  </tr>
                </thead>
                {accountingDimensions?.map((d) => (
                  <tbody>
                    <tr>
                      <td data-label="Product type">{d?.GL?.key}</td>
                      {/* <td data-label="Product name">{d?.GL?.value}&nbsp;</td> */}
                      <td data-label="Base unit">{d?.dimension2}&nbsp;</td>
                      <td data-label="CO2e unit">{d?.dimension3}&nbsp;</td>
                      <td data-label="CO2e kg">{d?.dimension4}&nbsp;</td>
                      <td data-label="Stakeholder source">
                        {d?.dimension5}&nbsp;
                      </td>
                      <td data-label="Manufacturer source">
                        {d?.dimension6}&nbsp;
                      </td>
                      <td
                        data-label="Manufacturer source"
                        onClick={(e) => _Navigate_EditPage(e, d?.id)}
                      >
                        <i className="fa fa-pencil" aria-hidden="true"></i>
                        &nbsp;
                      </td>
                      {/* <td data-label="Manufacturer source">{d?.dimension6}&nbsp;</td> */}
                    </tr>
                  </tbody>
                ))}
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountingDimensionsList;
